import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const DialogContentStyled = styled(DialogContent)(() => ({
  paddingBottom: '50px'
}));

export const SectionWrapperStyled = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '16px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px'
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  margin: '0 !important'
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
}));
